const getColorHex = color => {
  if (!color) return null;

  const globalColorKey = color.substring(4, color.length - 1);

  return getComputedStyle(document.documentElement).getPropertyValue(globalColorKey);
};

export default getColorHex;
